import { render, staticRenderFns } from "./SupplierDetailsTitle.vue?vue&type=template&id=0b4be562&"
import script from "./SupplierDetailsTitle.vue?vue&type=script&lang=js&"
export * from "./SupplierDetailsTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports